// tslint:disable
/**
 * Property Management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreatePropertyRequest } from '../models';
import { CreateTestPropertyRequest } from '../models';
import { GetPropertyItemResponse } from '../models';
import { GetPropertyListResponse } from '../models';
import { UpdatePropertyRequest } from '../models';
/**
 * PropertyApi - axios parameter creator
 * @export
 */
export const PropertyApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [customerCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyGet(customerCode?: string, options: any = {}): RequestArgs {
      const localVarPath = `/property`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (customerCode !== undefined) {
        localVarQueryParameter['customerCode'] = customerCode;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGet(id: string, options: any = {}): RequestArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling propertyIdGet.'
        );
      }
      const localVarPath = `/property/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {UpdatePropertyRequest} [updatePropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdPatch(
      id: string,
      updatePropertyRequest?: UpdatePropertyRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling propertyIdPatch.'
        );
      }
      const localVarPath = `/property/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof updatePropertyRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(updatePropertyRequest !== undefined ? updatePropertyRequest : {})
        : updatePropertyRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePropertyRequest} [createPropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyPut(createPropertyRequest?: CreatePropertyRequest, options: any = {}): RequestArgs {
      const localVarPath = `/property`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof createPropertyRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(createPropertyRequest !== undefined ? createPropertyRequest : {})
        : createPropertyRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateTestPropertyRequest} [createTestPropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyTestPost(
      createTestPropertyRequest?: CreateTestPropertyRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/property/test`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof createTestPropertyRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(createTestPropertyRequest !== undefined ? createTestPropertyRequest : {})
        : createTestPropertyRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PropertyApi - functional programming interface
 * @export
 */
export const PropertyApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [customerCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyGet(
      customerCode?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPropertyListResponse> {
      const localVarAxiosArgs = PropertyApiAxiosParamCreator(configuration).propertyGet(
        customerCode,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGet(
      id: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPropertyItemResponse> {
      const localVarAxiosArgs = PropertyApiAxiosParamCreator(configuration).propertyIdGet(
        id,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} id
     * @param {UpdatePropertyRequest} [updatePropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdPatch(
      id: string,
      updatePropertyRequest?: UpdatePropertyRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPropertyItemResponse> {
      const localVarAxiosArgs = PropertyApiAxiosParamCreator(configuration).propertyIdPatch(
        id,
        updatePropertyRequest,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreatePropertyRequest} [createPropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyPut(
      createPropertyRequest?: CreatePropertyRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPropertyItemResponse> {
      const localVarAxiosArgs = PropertyApiAxiosParamCreator(configuration).propertyPut(
        createPropertyRequest,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateTestPropertyRequest} [createTestPropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyTestPost(
      createTestPropertyRequest?: CreateTestPropertyRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = PropertyApiAxiosParamCreator(configuration).propertyTestPost(
        createTestPropertyRequest,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * PropertyApi - factory interface
 * @export
 */
export const PropertyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} [customerCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyGet(customerCode?: string, options?: any): AxiosPromise<GetPropertyListResponse> {
      return PropertyApiFp(configuration).propertyGet(customerCode, options)(axios, basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGet(id: string, options?: any): AxiosPromise<GetPropertyItemResponse> {
      return PropertyApiFp(configuration).propertyIdGet(id, options)(axios, basePath);
    },
    /**
     *
     * @param {string} id
     * @param {UpdatePropertyRequest} [updatePropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdPatch(
      id: string,
      updatePropertyRequest?: UpdatePropertyRequest,
      options?: any
    ): AxiosPromise<GetPropertyItemResponse> {
      return PropertyApiFp(configuration).propertyIdPatch(
        id,
        updatePropertyRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {CreatePropertyRequest} [createPropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyPut(
      createPropertyRequest?: CreatePropertyRequest,
      options?: any
    ): AxiosPromise<GetPropertyItemResponse> {
      return PropertyApiFp(configuration).propertyPut(createPropertyRequest, options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @param {CreateTestPropertyRequest} [createTestPropertyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyTestPost(
      createTestPropertyRequest?: CreateTestPropertyRequest,
      options?: any
    ): AxiosPromise<void> {
      return PropertyApiFp(configuration).propertyTestPost(createTestPropertyRequest, options)(
        axios,
        basePath
      );
    },
  };
};

/**
 * PropertyApi - object-oriented interface
 * @export
 * @class PropertyApi
 * @extends {BaseAPI}
 */
export class PropertyApi extends BaseAPI {
  /**
   *
   * @param {string} [customerCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public propertyGet(customerCode?: string, options?: any) {
    return PropertyApiFp(this.configuration).propertyGet(customerCode, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public propertyIdGet(id: string, options?: any) {
    return PropertyApiFp(this.configuration).propertyIdGet(id, options)(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} id
   * @param {UpdatePropertyRequest} [updatePropertyRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public propertyIdPatch(id: string, updatePropertyRequest?: UpdatePropertyRequest, options?: any) {
    return PropertyApiFp(this.configuration).propertyIdPatch(
      id,
      updatePropertyRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {CreatePropertyRequest} [createPropertyRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public propertyPut(createPropertyRequest?: CreatePropertyRequest, options?: any) {
    return PropertyApiFp(this.configuration).propertyPut(createPropertyRequest, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @param {CreateTestPropertyRequest} [createTestPropertyRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public propertyTestPost(createTestPropertyRequest?: CreateTestPropertyRequest, options?: any) {
    return PropertyApiFp(this.configuration).propertyTestPost(createTestPropertyRequest, options)(
      this.axios,
      this.basePath
    );
  }
}
